import styled from "styled-components";

export const OpenApiWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    position: relative;
    padding-top: 20px;
`;

export const OpenApiTitle = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    letter-spacing: 0.5px;
`;
export const OpenApiCard = styled.div`
    width: 98%;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 20px;

`;

export const OpenApiInfo = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    margin-bottom: 16px;
`;

export const InfoLabel = styled.span`
    font-size: 12px;
    color: #666666;
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const InfoValue = styled.span`
    font-size: 14px;
    color: #333;
    word-break: break-all;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    background-color: #f5f5f5;
    padding: 8px 12px;
    border-radius: 4px;
    border: 1px solid #eee;
`;

export const InfoSwaggerLink = styled.span`
    font-size: 14px;
    color: #666666;
    margin-bottom: 4px;
    padding: 16px 12px;
    letter-spacing: 0.5px;
    text-align: right;
`;
